import { TweenMax } from 'gsap';
import { getGameSize, IGameSizeInfo } from '../Config/Levels';
import { LoadingScreen } from '../UI/Loading/LoadingScreen';
import HudView from './HudView';
import TutorialView from './TutorialView';
import Core from '../Core/Core';
import { Views } from '../State/reducers/view';
import { sizer } from '../index';

export interface IView extends PIXI.Container {
    update?: () => void;
    resize: (sizeInfo: IGameSizeInfo) => void;
    cleanUp?: () => void;
}

export default class GameView extends PIXI.Container {
    public view: IView;
    public hud: HudView;
    public loadScreen: LoadingScreen;
    public tutorial: TutorialView;
    public isLoading: boolean = false;
    private bootload: boolean = true;

    constructor() {
        super();
    }

    public addHud(hud: HudView) {
        this.hud = hud;
    }

    public addTutorial(tutorial: TutorialView) {
        this.tutorial = tutorial;
    }

    public changeView(view?: IView) {
        if (this.view) {
            this.view.destroy();
            this.view = null;
        }
        if (view) {
            this.addChildAt(view, 0);
            this.view = view;
        } else {
            const c = new PIXI.Container();
            this.addChildAt(c, 0);
        }
    }

    public resize(sizeInfo: IGameSizeInfo) {
        this.scale.x = this.scale.y = sizeInfo.gameScale;
        if (this.view) {
            this.view.resize(sizeInfo);
        }

        if (this.hud) {
            this.hud.resize(sizeInfo);
        }

        if (this.loadScreen) {
            this.loadScreen.resize(sizeInfo);
        }
    }

    public update(view: string, retrieving: boolean) {
        if (this.loadScreen) {
            this.loadScreen.update(this.getLoadingText(view, retrieving));
        }
    }

    public addLoading() {
        if (!this.loadScreen) {
            this.loadScreen = new LoadingScreen();
            this.addChild(this.loadScreen);
        }

        TweenMax.killTweensOf(this.loadScreen);

        this.loadScreen.resize(getGameSize());
        this.loadScreen.alpha = 0;

        TweenMax.to(this.loadScreen, 0.2, {
            alpha: 1,
        });
    }

    public removeLoading() {
        if (!this.loadScreen) {
            return;
        }
        const { loadScreen } = this;
        this.loadScreen = null;

        TweenMax.killTweensOf(loadScreen);
        TweenMax.to(loadScreen, 0.2, {
            alpha: 0,
            onComplete: () => {
                loadScreen.destroy();
            },
        });
    }

    public setLoading(isLoading: boolean) {
        this.isLoading = isLoading;
        if (this.isLoading) {
            if (this.bootload) {
                sizer();
            }
            this.addLoading();
            this.bootload = false;
        } else {
            this.removeLoading();
        }
    }

    private getLoadingText(view: string, retrieving: boolean): string {
        const viewText = view === Views.BOOT ? '' : Core.local.getText(view);
        let loadtxt = Core.local.getText('loading') + ' ' + viewText + '...';
        if (retrieving) {
            loadtxt = Core.local.getText('connecting');
        }
        return loadtxt;
    }

    public destroy() {
        TweenMax.killAll();
    }
}
